const service = function(
	Http,
	$http,
	$rootScope,
	$q,
	api,
	Session,
	Basket
) {
	"ngInject"

	this.get = () => Session.get('invoices');

	this.refresh = () => $http.get(api+'/v1/invoices?scope=session').then(function(response) {
		Session.set('invoices', response.data);
		$rootScope.$broadcast('INVOICES_CHANGED');
		return $q.resolve();
	});

	this.create = (data) => $http.post(api+'/v1/invoice', data).then(res => {
		Basket.refresh();
		this.refresh();
	});

	this.details = (id) => $http.get(api+'/v1/invoice/'+id);

	this.all = (scope) => $http.get(api+'/v1/invoices?scope='+scope);

	this.send = (id) => $http.get(api+'/v1/invoice/send/'+id);
	this.save = (id) => $http.get(api+'/v1/invoice/save/'+id);
	this.print = (id) => $http.get(api+'/v1/invoice/print/'+id);
	// this.cancel = (id, revert) => $http.get(api+'/v1/invoice/cancel/'+id);
	this.cancel = (id, revert) => $http.post(api+'/v1/invoice/cancel/'+id, {
		revert: revert
	}).then(res => {
		Basket.refresh();
		this.refresh();
	});

	this.validate = (data) => $http.post(api + '/v1/invoice/validate', data);

	this.flush = function() {
		Session.remove('invoices');
		$rootScope.$broadcast('INVOICES_CHANGED');
	}

	this.total = function() {
		var invoices = Session.get('invoices');
		var result = 0;
		if (invoices && invoices.length > 0) {
			result = invoices.length;
		}
		return result;
	}

	this.address = (data) => $http.post(api+'/v1/customer/address', data);

}

export default service;


// WEBPACK FOOTER //
// ./app/shared/services/invoice.service.js